import { render, staticRenderFns } from "./OfficeBuilding.vue?vue&type=template&id=518ee28c&scoped=true"
import script from "./OfficeBuilding.vue?vue&type=script&lang=js"
export * from "./OfficeBuilding.vue?vue&type=script&lang=js"
import style0 from "./OfficeBuilding.vue?vue&type=style&index=0&id=518ee28c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ee28c",
  null
  
)

export default component.exports